var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dots-vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4974 10.833C10.9576 10.833 11.3307 10.4599 11.3307 9.99967C11.3307 9.53944 10.9576 9.16634 10.4974 9.16634C10.0372 9.16634 9.66406 9.53944 9.66406 9.99967C9.66406 10.4599 10.0372 10.833 10.4974 10.833Z",
    stroke: "#6366F1",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4974 4.99967C10.9576 4.99967 11.3307 4.62658 11.3307 4.16634C11.3307 3.7061 10.9576 3.33301 10.4974 3.33301C10.0372 3.33301 9.66406 3.7061 9.66406 4.16634C9.66406 4.62658 10.0372 4.99967 10.4974 4.99967Z",
    stroke: "#6366F1",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4974 16.6663C10.9576 16.6663 11.3307 16.2932 11.3307 15.833C11.3307 15.3728 10.9576 14.9997 10.4974 14.9997C10.0372 14.9997 9.66406 15.3728 9.66406 15.833C9.66406 16.2932 10.0372 16.6663 10.4974 16.6663Z",
    stroke: "#6366F1",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.25457e504ddb79daa7147aa5c121ee55.svg";
export { ForwardRef as ReactComponent };